<template lang="pug">
.hero
  .hero-background-color-clipped
  .hero-background-center
  .centered-content
    h1 
      span Simple, <br/>
      span Powerful <br/>
      span Cash Flows <br/>
    h2 Navigating your business has never been easier.
    //- h2 We're here to help and would love to hear more about your business.
    bw-waitlist
    //a.bw-button.push-button(href="https://freebusy.io/r.j.w.cross@gmail.com/budgee-introduction") Book a time with us
  //.next
    i.fas.fa-arrow-alt-circle-down
  bw-wavey-bottom
</template>

<script>
import BwWaveyBottom from "@/components/shared/BwWaveyBottom";
import BwWaitlist from "@/components/shared/BwWaitlist";

export default {
  components: {
    BwWaveyBottom,
    BwWaitlist
  }
};
</script>

<style lang="stylus" scoped>
@import "./../../assets/styles/mixins.styl"
.centered-content
  height: 100%
  padding-top: 30px
  z-index: 3

.hero
  position: relative
  height: 700px
  h1
    margin: 0
    padding-top: 70px
    text-align: left
    font-weight: 500
    font-size: 50px
    line-height: 60px
    color: rgba(0,0,0,0.77)
    margin: 0 0 18px
    max-width: 690px
  h2
    color: rgba(0,0,0,0.67)
    padding-left: 3px
    max-width: 350px
    line-height: 30px
    //margin-bottom: 60px
    font-size: 20px
    font-weight: 400
  .hero-background-color-clipped
    position: absolute
    top: 0
    left: 0
    right: 0
    width:  100%
    height: 450px
    background: #eaf1f2 //#5ac496
  .hero-background-center
    background-image: url('../../assets/images/budgee-notebook-on-desk.png')
    background-repeat: no-repeat
    background-size: contain
    height: 100%
    position: absolute
    top: 10px
    bottom: 0
    left: 0
    right: 0
    margin: 0 auto
    max-width: 1610px
    width: 100%
    z-index: 2
  .push-button
    margin-top: 50px
    padding-left: 60px
    padding-right: 60px
    margin-left: 0
    display: flex
    width: fit-content
// .next
//   display: flex
//   width: 100%
//   justify-content: center
//   position: absolute
//   font-size: 52px
//   margin-top: -50px
//   z-index: 10
//   i
//     background: white
//     //box-shadow: 0px 0px 5px 4px rgba(0,0,0,0.2)
//     width: 50px
//     height: 50px
//     border-radius: 25px
//     color: #bcc0c8
//     text-align: center
//     transition: 0.2s
//     cursor: pointer
//     &:hover
//       color: #999
@media mq-tablet-wide
  .hero
    height: 800px
    h1,h2
      text-align: center
      max-width: none
    h1
      padding-top: 10px
    h2
      margin-bottom: 20px
    .push-button
      margin: 20px auto 0
    .hero-background-center
      top: 380px
      margin-left: -29%
      width: 123%
    .hero-background-color-clipped
      height: 550px
    ::v-deep .d-flex
      justify-content: center

@media mq-tablet
  .hero
    h1
      padding-top: 0
      font-size: 30px
      line-height: 40px
    h2
      font-size: 16px
      line-height: 25px
    .hero-background-center
      top: 300px
      margin-left: -58%
      width: 174%
@media mq-mobile
  .hero
    height: 600px
    .hero-background-color-clipped
      height: 350px
</style>
